<template>
  <svg
    width="19"
    height="19"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="fill-current"
  >
    <path d="M3 11.5l17-7.5-6.5 17-2.5-7z" />
  </svg>
</template>

<script>
export default {
  name: 'SendIcon'
}
</script>
